import { useState, useEffect } from 'react'
import axios from 'axios'
import Loader from '@/components/Loader/Loader'
import Blog from '@/layouts/Blog/Blog'
import './style.scss'

export default function HomePage() {
  const [articles, setArticles] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/v1/articles/0zlivnsw0f`)
      .then((res) => {
        setArticles(res.data.articles)
      })
      .catch((err) => {
        setError(err.response?.data?.message ?? 'Wystąpił błąd.')
      })
      .finally(() => setLoading(false))
  }, [])

  if (error) {
    return (
      <div className="alert alert-danger my-3" role="alert">
        {error}
      </div>
    )
  }

  return loading ? <Loader size="2" /> : <Blog articles={articles} />
}